// extracted by mini-css-extract-plugin
module.exports = {"icon":"_0b812da","dividerText":"_7ee9c09","activeLink":"_024082f"};